import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { yieldToEventLoop } from '../../../runtime/yield-to-event-loop.js';
import { withCodeNavCacheSqlite } from '../../../sqlite/code-nav-cache/database.js';
import { createCodeNavYieldState, yieldDuringCodeNavWork } from '../../yield-during-work.js';
import type { CodeNavLocation } from '../../types.js';
import { getSymbolIndexParentContext } from '../sqlite/symbol-index-sqlite.js';
import { findTagsByName, loadFileTags } from '../storage/symbol-parent-file-map.js';
import { pickPrimaryTagAtPosition } from './tag-position.js';
import { rowToLocation } from './tag-query-shared.js';

export async function queryReferencesAt(
  parentPath: string,
  filePath: string,
  line: number,
  column: number,
): Promise<CodeNavLocation[]> {
  await yieldToEventLoop();
  const resolved = normalizeResolvedPath(parentPath);

  const rows = await withCodeNavCacheSqlite((db) => {
    const ctx = getSymbolIndexParentContext(db, resolved);
    if (ctx == null) return null;

    const fileRows = loadFileTags(db, ctx, filePath);
    const primary = pickPrimaryTagAtPosition(fileRows, filePath, line, column);
    if (!primary) return null;

    return findTagsByName(db, ctx, primary.name);
  });

  await yieldToEventLoop();
  if (!rows) return [];

  const state = createCodeNavYieldState();
  const locations: CodeNavLocation[] = [];
  for (const row of rows) {
    await yieldDuringCodeNavWork(state);
    locations.push(rowToLocation(row));
  }
  return locations;
}
